import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data.posts || [])); }, []);

  return (
    <div>
      <section className="hero-bg py-16">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-gold uppercase tracking-widest text-sm font-semibold">Blog</div>
          <h1 className="font-heading text-4xl text-primary-blue mt-3">Conseils, actualités et guides audition</h1>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group" data-testid={`blog-card-${p.slug}`}>
            <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden card-lux h-full flex flex-col">
              {p.image_url && <img src={p.image_url} alt={p.title} className="w-full h-48 object-cover" />}
              <div className="p-6 flex-1 flex flex-col">
                <div className="font-heading text-xl text-primary-blue group-hover:text-[#0a1d36]">{p.title}</div>
                <p className="mt-3 text-slate-600 flex-1">{p.summary}</p>
                <span className="mt-4 text-primary-blue inline-flex items-center gap-1 text-sm font-medium">
                  Lire l'article <ArrowRight size={14} />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
